// ============================================================
// useFeeInstallments Hooks
// ============================================================

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { feeInstallmentService } from '@/services/feeInstallmentService';

export function useFeeInstallments(feeStructureItemId) {
  return useQuery({
    queryKey: ['feeInstallments', feeStructureItemId],
    queryFn: () => feeInstallmentService.getInstallments(feeStructureItemId),
    enabled: !!feeStructureItemId,
  });
}

export function useCreateFeeInstallments() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ feeStructureItemId, payloadArray }) =>
      feeInstallmentService.createInstallments(feeStructureItemId, payloadArray),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['feeInstallments', variables.feeStructureItemId] });
    },
  });
}

export function useUpdateFeeInstallment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ installmentId, feeStructureItemId, payload }) =>
      feeInstallmentService.updateInstallment(installmentId, payload),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['feeInstallments', variables.feeStructureItemId] });
    },
  });
}

export function useDeleteFeeInstallment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ installmentId, feeStructureItemId }) =>
      feeInstallmentService.deleteInstallment(installmentId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['feeInstallments', variables.feeStructureItemId] });
    },
  });
}
